import { render, staticRenderFns } from "./edit-qianzhang.vue?vue&type=template&id=6cfbed40&scoped=true"
import script from "./edit-qianzhang.vue?vue&type=script&lang=js"
export * from "./edit-qianzhang.vue?vue&type=script&lang=js"
import style0 from "./edit-qianzhang.vue?vue&type=style&index=0&id=6cfbed40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfbed40",
  null
  
)

export default component.exports